import { useIsUserC360, useIsUserExempt } from '@/features/account/services/User/hooks'
import { useAtom } from 'jotai'
import { membershipEntryPointBannerDismissedAtom } from '@/features/account/state/UserPreferences/atom'

export function useShouldFetchMembershipEntryPointBanner() {
  const [isDismissed] = useAtom(membershipEntryPointBannerDismissedAtom)
  const isExempt = useIsUserExempt()
  const isCircle360 = useIsUserC360()
  const isDisabled =
    isCircle360 ||
    // don't fetch if the user has previously closed this banner
    isDismissed ||
    // don't fetch for exempt users
    isExempt
  return !isDisabled
}
